import { memo } from 'react';

import { SettingsSubSideNavItem } from '~/components/v2/components/workspace/settings-nav/item/SettingsSubSideNavItem';
import { SettingsSubSideNavSectionHeader } from '~/components/v2/components/workspace/settings-nav/item/SettingsSubSideNavSectionHeader';
import { useAccountSettingsNavItems } from '~/components/v2/components/workspace/settings-nav/useAccountSettingsNavItems';

export const SettingsSubSideNavAccountSection = memo(() => {
  const { items } = useAccountSettingsNavItems();

  return (
    <section className="flex flex-col pt-4" data-testid="SETTINGS_SUB_SIDE_NAV_ACCOUNT_SECTION">
      <SettingsSubSideNavSectionHeader className="pt-1" data-testid="SETTINGS_SUB_SIDE_NAV_ACCOUNT_HEADER">
        My Account
      </SettingsSubSideNavSectionHeader>
      {items.map((item) => (
        <SettingsSubSideNavItem item={item} key={item.id} />
      ))}
    </section>
  );
});

SettingsSubSideNavAccountSection.displayName = 'SettingsSubSideNavAccountSection';
